export default __webpack_public_path__ + "static/media/Upload-PNG-Image-File.a26a4340.png";